// import shop from '../../api/shop'
import graphql from '../../api/graphql'
import gql from 'graphql-tag'

// initial state
// shape: [{ id, name, ip, state, isLoading }]
const state = {
  profile: {
    id: '',
    firstName: '',
    lastName: '',
    nickname: '',
    email: '',
    roles: 0,
    security: 'nobody',
    city: '',
    countryCode3: '',
    about: '',
    picture: '',
  },
  users: []
}

// getters
const getters = {
}

// actions
const actions = {
  userGetProfile ({ state, dispatch, commit }) {
    let graphQuery = gql`{
        user {
          id,
          firstName,
          lastName,
          nickname,
          email,
          roles,
          security,
          city,
          countryCode3,
          about,
          picture,
        }
      }
      `
    graphql.query(graphQuery)
      .then(json => {
        commit('userSetProfile', json.data.user)
      })
      .catch(gqlResponse => {
        graphql.handleError(gqlResponse, 'Error getting profile:', dispatch)
      })
  },

  userUpdateProfile ({ state, dispatch, commit }, user ) {
    let graphQuery = gql`
      mutation User ($input: UserInput!) {
        user(input: $input) {
          id,
          firstName,
          lastName,
          nickname,
          email,
          city,
          countryCode3,
          about,
          picture,
        }
      }
    `
    let value = Object.assign({}, user)
    delete value.picture
    graphql.query(graphQuery, {
      input: value
    })
    .then(json => {
      console.log(json)
      if (json.data) {
        commit('userSetProfile', json.data.user)
        dispatch('notify', { type: 'success', message: 'Profile updated'})
      }
    })
    .catch(gqlResponse => {
      graphql.handleError(gqlResponse, 'Error updating profile:', dispatch)
    })
  },

  userDelete ({ state, commit }, id) {
    commit('deleteUser', id)
  },

}

// mutations
const mutations = {
  serverToggleState(state, server) {
    // const s = server.state
    // if (s == 'running') {
    //   server.state = 'unknown'
    // } else if (s == 'unknown') {
    //   server.state = 'running'
    // }
    server.isLoading = !server.isLoading
  },

  userSetProfile(state, user) {
    Object.assign(state.profile, user)
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}